import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    reviewerArticle: {},
    reviewernotification: {},
    reviewersendmail: {},
    reviewForm: {}

};

const ReviewerArticleSlice = createSlice({
    name: 'reviewerarticle',
    initialState,
    reducers: {
        setToast(state, action) {
            state.reviewernotification = action.payload
        },
        setReviewerArticle(state, action) {
            state.reviewerArticle = action.payload
        },
        setReviewerSendMail(state, action) {
            state.reviewersendmail = action.payload
        },
        setReviewForm(state, action) {
            state.reviewForm = action.payload
        }


    },
});
export const ReviewerArticleListApi = (tokendata, page, limit, search,journal_id) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/reviewer/manuscript/list?page=${page}&limit=${limit}&search=${search}&journal_uuid=${journal_id}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jfdd")
            dispatch(setReviewerArticle(res?.data))
        })
        .catch((err) => {
            console.log(err?.response, "errerrr");

        })
}

export const sendEmailApi = (payload, tokendata) => async (dispatch) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/author/sendEmailToEditorOffice`, payload,
        {
            headers: {
                "Authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jhri")
            dispatch(setReviewerSendMail(res?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response)
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })
}


export const RevieweruploadFilesApi = (tokendata, uuid, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptupdate/attachMoreFiles/${uuid}`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}

export const ReviewFormApi = (tokendata, payload) => async (dispatch) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/reviewer/SubmitReview`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    )
        .then((res) => {
            console.log(res, "njd939dj");
            dispatch(setReviewForm(res?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))

        })
        .catch((err) => {
            console.log(err?.response, "jdfss");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )


        })
}

export const ReviewerArticleAcceptDeclineApi = (tokendata, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/reviewer/agree/decline`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}











export const { setToast, setReviewerArticle, setReviewerSendMail, setReviewForm } = ReviewerArticleSlice.actions;
const ReviewerArticleReducer = ReviewerArticleSlice.reducer;

export default ReviewerArticleReducer;
